import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const TeamImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      teamImage: file(
        relativePath: { eq: "components/TeamCard/images/team.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 2761, maxHeight: 2500, cropFocus: NORTH) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.teamImage.childImageSharp.fluid} {...props} />
}

export default TeamImage
